import axios from "axios";
import config from "../Config/applicationEnv";

export const getBaseUrl = () => config.BASE_URL || "https://apipostman.onlinecu.in/";

const axiosInstance = axios.create({
  baseURL: getBaseUrl(),
});

axiosInstance.interceptors.request.use(
  (reqConfig) => {
    try {
      const slotbook = localStorage.getItem("slotbook");
      const data = slotbook ? JSON.parse(slotbook) : null;
      const token = data?.accessToken;
      if (token) {
        reqConfig.headers.Authorization = `Bearer ${token}`;
      }
    } catch (e) {
      // ignore
    }
    return reqConfig;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
